import React from 'react';
import './CircularProgress.css';

const CircularProgress = ({ progress = 0, size = 32, strokeWidth = 3, message = '' }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (progress / 100) * circumference;
  const displayProgress = Math.round(progress);

  // Determine color based on progress
  const getProgressClass = () => {
    if (displayProgress >= 100) return 'complete';
    if (displayProgress >= 60) return 'high-progress';
    if (displayProgress >= 30) return 'medium-progress';
    return 'low-progress';
  };

  const getStrokeColor = () => {
    if (displayProgress >= 100) return '#28a745'; // Green
    if (displayProgress >= 60) return '#0d6efd'; // Blue
    if (displayProgress >= 30) return '#ffc107'; // Yellow
    return '#dc3545'; // Red
  };

  return (
    <div 
      className={`circular-progress-container ${displayProgress < 100 ? 'loading' : ''}`}
      style={{ width: size, height: size }}
      title={message || `${displayProgress}% complete`}
    >
      <svg
        className="circular-progress-svg"
        width={size}
        height={size}
      >
        {/* Background circle */}
        <circle
          className="circular-progress-background"
          stroke="#e6e6e6"
          fill="transparent"
          strokeWidth={strokeWidth}
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
        {/* Progress circle */}
        <circle
          className={`circular-progress-bar ${getProgressClass()}`}
          stroke={getStrokeColor()}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          r={radius}
          cx={size / 2}
          cy={size / 2}
        />
      </svg>
      {/* Progress text */}
      <div className="circular-progress-text" style={{ color: getStrokeColor() }}>
        <span>{displayProgress}%</span>
      </div>
    </div>
  );
};

export default CircularProgress;
